import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "btn btn-success" }
const _hoisted_5 = { class: "table table-bordered table-hover" }
const _hoisted_6 = { class: "text-dark" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_10 = { class: "dropdown-item" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttributeDeleterDialog = _resolveComponent("AttributeDeleterDialog")!
  const _component_AttributeDependenciesDialog = _resolveComponent("AttributeDependenciesDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AttributeDeleterDialog, {
      viewModel: _ctx.attrDeleterDialog,
      onDeleteAttribute: _ctx.handleDeleteAttributeCommand,
      onShowDependencies: _ctx.handleShowAttributeDependencies
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteAttribute", "onShowDependencies"]),
    _createVNode(_component_AttributeDependenciesDialog, { viewModel: _ctx.attrDependenciesDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.goalName), 1 /* TEXT */),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              ActivePage: "weighted-scores",
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ScoringEnabled: false
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId"]),
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Create score ", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, _ctx.url_CreateWeightedScorePage]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, " Score "),
                  _createElementVNode("th", null, " Weights "),
                  _createElementVNode("th", null, " Criterion "),
                  _createElementVNode("th", { style: {"width":"90px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scores, (s) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: s.Id
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [
                        _createElementVNode("strong", null, _toDisplayString(s.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, _ctx.url_EditWeightedScorePage(s.Id)]
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_7, _toDisplayString(s.Description), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(s.WeightsSetName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(s.CriterionName), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[4] || (_cache[4] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, [
                          _createTextVNode(" Actions "),
                          _createElementVNode("span", { class: "caret" })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Edit", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, _ctx.url_EditWeightedScorePage(s.Id)]
                          ]),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.handleShowAttributeDependencies(s.AttributeId))
                          }, "View dependencies", 8 /* PROPS */, _hoisted_11),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.handleShowAttributeDeleter(s.AttributeId))
                          }, "Delete", 8 /* PROPS */, _hoisted_12)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}